<template>
  <v-select
    v-model="selectedProject"
    class="input-projects ma-md-2 mt-1"
    dark
    background-color="primary"
    :items="tenantsList"
    placeholder="Projects"
    :item-value="item => item"
    item-text="name"
    single-line
    solo
    dense
    @change="onChangeProject"
  />
</template>

<script>
export default {
  name: "SelectProject",
  props: {
    tenantsList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectedProject: {}
  }),
  mounted() {
    this.$set(this, "selectedProject", this.getItemFromLocalStore());
    this.setTheme(this.selectedProject.id);
  },
  destroyed() {
    this.setTheme("default");
  },
  methods: {
    onChangeProject() {
      const projectItem = this.selectedProject;
      this.setTheme(projectItem.id);
      this.$store.dispatch("AppStore/setTenant", projectItem.id);
      this.$emit("update");
    },
    setTheme(themeName) {
      const theme = Object.values(this.$vuetify.theme.defaults).find(
        i => i.name === themeName
      );
      const name = theme.name;
      const dark = theme.dark || {};
      const light = theme.light || {};
      // set themes
      Object.keys(dark).forEach(i => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;
    },
    getItemFromLocalStore() {
      let value = this.$store.getters["AppStore/getTenant"];
      return this.tenantsList.find(i => i.id === value);
    }
  }
};
</script>

<style scoped>
.input-projects {
  min-width: 250px;
  max-width: 250px;
  height: 38px;
}
</style>
